import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d380f1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center ga-2" }
const _hoisted_2 = { class: "text-body-1 font-weight-bold flex-grow-1 texto-largo" }
const _hoisted_3 = { class: "text-caption text-medium-emphasis" }
const _hoisted_4 = {
  key: 0,
  class: "text-caption text-medium-emphasis texto-largo"
}
const _hoisted_5 = { class: "d-flex align-center ga-2" }
const _hoisted_6 = { class: "text-body-2 flex-grow-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-medium-emphasis" }, " · ", -1))
const _hoisted_8 = { class: "text-caption text-medium-emphasis mt-1" }
const _hoisted_9 = { class: "d-flex align-center ga-2" }
const _hoisted_10 = { class: "text-body-2 font-weight-bold flex-grow-1 texto-largo" }
const _hoisted_11 = {
  key: 0,
  class: "font-weight-regular text-medium-emphasis"
}
const _hoisted_12 = {
  key: 0,
  class: "text-caption text-medium-emphasis texto-largo"
}
const _hoisted_13 = { class: "text-body-2" }
const _hoisted_14 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_15 = {
  key: 1,
  class: "text-medium-emphasis text-no-wrap"
}
const _hoisted_16 = {
  key: 1,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-body-2 text-warning flex-grow-1" }, "Hueco libre", -1))
const _hoisted_18 = { class: "text-subtitle-1 text-center" }

import { computed, ref, toRef } from "vue";

import { useTorneoCerrado } from "@/composables/useTorneoCerrado";
import type { EquipoDTO, InscripcionTorneoDTO } from "@/interfaces/Inscripcion";
import { bandoLista, estadoLista } from "@/utils/estadoLista";
import {
  convertirFecha,
  obtenerFechaActual,
  formatFechaSpaWhitoutAsync,
} from "@/utils/Fecha";
import {
  eliminarEquipoAsync,
  eliminarMiembroEquipoAsync,
} from "@/services/InscripcionesService";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import {
  CrearListaTorneoRequestDTO,
  ListaJugador,
  ModificarListaTorneoRequestDTO,
  RequesListaDTO,
} from "@/interfaces/Lista";
import ModalVerLista from "@/components/Inscripcion/ModalVerLista.vue";
import ModalEnviarLista from "@/components/Inscripcion/ModalEnviarLista.vue";
import {
  getListaById,
  modificarListaTorneo,
  subirListaTorneo,
} from "@/services/ListasService";
import { Torneo } from "@/interfaces/Torneo";
import ModalCambiarEstadoListaEquipos from "./ModalCambiarEstadoListaEquipos.vue";
import { getUsuariosNoInscritosTorneoAsync } from "@/services/UsuariosService";
import { UsuarioSinEquipoDTO } from "@/interfaces/Usuario";
import ModalAddMiembroEquipo from "@/components/GestionTorneos/Equipos/ModalAddMiembroEquipo.vue";
import PuntosExtra from "@/components/GestionTorneos/PuntosExtra.vue";
import InterruptorPago from "@/components/GestionTorneos/InterruptorPago.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardInfoEquipo',
  props: {
    equipo: {},
    torneo: {}
  },
  emits: ["delete-team", "puntos-extra"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
// Cerrado, ya no entra ni sale nadie
const cerrado = useTorneoCerrado();

const isOpenMenuAcciones = ref<{ [id: number]: boolean }>({});
const isExpanded = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const showSuccessModalEliminarEquipo = ref<boolean>(false);
const showVerListaModal = ref<boolean>(false);
const showEnviarCambiarListaModal = ref<boolean>(false);
const showCambiarEstadoLista = ref<boolean>(false);
const showSuccessModalLista = ref<boolean>(false);
const showErrorModalLista = ref<boolean>(false);
const showModalRegistrarMiembroEquipo = ref<boolean>(false);
const showErrorModalEliminarMiembroEquipo = ref<boolean>(false);
const showSuccessModalEliminarMiembroEquipo = ref<boolean>(false);
const showConfirmModal = ref(false);
const confirmAction = ref<() => void>();
const confirmTitle = ref("¿Estás seguro?");
const confirmText = ref("Esta acción no se puede deshacer.");
const currentInscripcionId = ref<number>();
const currentIdLista = ref<number>(0);
const currentUsuarioId = ref<number>();
const currentEmailOrganziador = ref<string>();
const currentNick = ref<string>();
const currentTorneoId = ref<number>();
const currentEstadoLista = ref<string>();
const hasLista = ref<boolean>(false);
const listaJugador = ref<ListaJugador>();
const jugadoresSinEquipo = ref<UsuarioSinEquipoDTO[]>([]);
const inscripcionesEquipo = ref<InscripcionTorneoDTO[]>([
  ...props.equipo.inscripciones,
]);
const esPago = toRef(props.equipo, "esPago");
const pagoCambiado = (nuevo: "SI" | "NO") => {
  esPago.value = nuevo;
};

const emit = __emit;

// Los de todos sus miembros: es lo que suma el equipo en la clasificación
const puntosExtraEquipo = computed(() =>
  inscripcionesEquipo.value.reduce((total, i) => total + (i.puntosExtra ?? 0), 0)
);

//Spiner
const isCargandoAccion = ref(false);
const mensajeCarga = ref("Cargando...");

const showErrorModal = ref<boolean>(false);
const toggleExpand = () => {
  isExpanded.value = !isExpanded.value;
};

const numeroMiembrosEquipo = ref<number>(0);
const equipoConHuecos = computed(() => {
  const miembros = inscripcionesEquipo.value ?? [];
  const faltantes = Math.max(
    0,
    (numeroMiembrosEquipo.value ?? 0) - miembros.length
  );
  return [...miembros, ...Array(faltantes).fill(null)];
});
const esParejas = computed(() => props.torneo.tipoTorneo === "Parejas");
const esListaConjunta = computed(
  () => esParejas.value && props.torneo.listaPorPareja === true
);
// La lista conjunta va en la inscripción del capitán, o en la que ya la tenga
const idInscripcionListaPareja = computed(
  () =>
    (
      inscripcionesEquipo.value.find((i) => i.idLista) ??
      inscripcionesEquipo.value.find((i) => i.idUsuario === props.equipo.idCapitan)
    )?.idInscripcion
);
const listasNecesarias = computed(() =>
  esListaConjunta.value ? 1 : numeroMiembrosEquipo.value
);
const listasOk = computed(() => {
  if (esListaConjunta.value)
    return inscripcionesEquipo.value.some(
      (i) =>
        i.idInscripcion === idInscripcionListaPareja.value &&
        i.estadoLista === "OK"
    )
      ? 1
      : 0;
  return inscripcionesEquipo.value.filter((i) => i.estadoLista === "OK").length;
});
const equipoIncompleto = computed(() => {
  return listasOk.value < listasNecesarias.value;
});

const miembrosPorTipo: Record<string, number> = {
  Individual: 1,
  Parejas: 2,
  Equipos_2: 2,
  Equipos_4: 4,
  Equipos_6: 6,
};
numeroMiembrosEquipo.value =
  miembrosPorTipo[props.torneo.tipoTorneo ?? "Individual"] || 1;

const verLista = async (idLista: number, nombre: string, ejercito: string) => {
  isLoading.value = true;
  try {
    const responseLista = await getListaById(idLista);
    const listaJugadorDTO: ListaJugador = {
      listaData: responseLista.data.listaData,
      nick: nombre,
      nombreEjercito: ejercito,
    };
    listaJugador.value = listaJugadorDTO;
    showVerListaModal.value = true;
  } catch (error) {
    // axios lanza en respuestas no 2xx; sin esto el spinner persistente se quedaba abierto
    console.error("Error al cargar la lista:", error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
  }
};

const enviarCambiarLista = (
  idInscripcion: number | undefined,
  listaData: string,
  idUsuario: number,
  nick: string,
  idLista: number
) => {
  currentInscripcionId.value = idInscripcion;
  currentUsuarioId.value = idUsuario;
  currentNick.value = nick;
  currentIdLista.value = idLista;
  if (!listaData) hasLista.value = false;
  else hasLista.value = true;

  showEnviarCambiarListaModal.value = true;
};

const guardarLista = async (newLista: RequesListaDTO) => {
  isCargandoAccion.value = true;
  const miembroIndex = inscripcionesEquipo.value.findIndex(
    (m) => m.idInscripcion === currentInscripcionId.value
  );


  if (miembroIndex === -1) {
    isCargandoAccion.value = false;
    showErrorModalLista.value = true;
    return;
  }

  const miembro = inscripcionesEquipo.value[miembroIndex];

  const esModificacion = !!miembro.idLista;
  
  try {
    let nuevoIdLista = miembro.idLista;

    if (!currentInscripcionId.value) {
      console.error('ID de inscripción no disponible');
      return;
    }

    if (esModificacion && !miembro.idLista) {
      console.error('ID de lista no disponible para modificación');
      return;
    }

    if (esModificacion) {
      mensajeCarga.value = "Modificando lista...";

      const requestLista: ModificarListaTorneoRequestDTO = {
        idInscripcion: currentInscripcionId.value ,
        idLista: miembro.idLista,
        listaData: newLista.listaData,
        ejercito: newLista.ejercito,
        idUsuario: newLista.idUsuario,
        idTorneo: props.torneo.idTorneo,
      };

      await modificarListaTorneo(requestLista);
    } else {
      mensajeCarga.value = "Enviando lista...";

      const requestLista: CrearListaTorneoRequestDTO = {
        idInscripcion: currentInscripcionId.value,
        listaData: newLista.listaData,
        ejercito: newLista.ejercito,
        idUsuario: newLista.idUsuario,
        idTorneo: props.torneo.idTorneo,
        nick: newLista.nick,
        nombreEquipo: props.equipo.nombreEquipo ?? "Sin nombre",
      };

      const response = await subirListaTorneo(requestLista);
      nuevoIdLista = response.data?.idLista;
    }

    // Reemplazo reactivo del objeto completo
    inscripcionesEquipo.value[miembroIndex] = {
      ...miembro,
      estadoLista: "ENTREGADA",
      listaData: newLista.listaData,
      ejercito: newLista.ejercito.name,
      idLista: nuevoIdLista,
      fechaEntregaLista: obtenerFechaActual(),
    };

    showSuccessModalLista.value = true;
  } catch (error) {
    console.error("Error al guardar/modificar lista:", error);
    showErrorModalLista.value = true;
  } finally {
    isCargandoAccion.value = false;
  }
};

const cambiarEstadoLista = (
  idInscripcion: number,
  estadoLista: string,
  nick: string
) => {
  currentInscripcionId.value = idInscripcion;
  currentNick.value = nick;
  currentEstadoLista.value = estadoLista;
  showCambiarEstadoLista.value = true;
};
const cambiarEstado = (payload: {
  field: keyof InscripcionTorneoDTO;
  value: unknown;
}) => {
  const { field, value } = payload;

  const index = inscripcionesEquipo.value.findIndex(
    (i) => i.idInscripcion === currentInscripcionId.value
  );

  if (index !== -1) {
    // Aseguramos reactividad reemplazando el objeto completo
    inscripcionesEquipo.value[index] = {
      ...inscripcionesEquipo.value[index],
      [field]: value,
    };
  }
};

const abrirModalConfirmacion = (
  titulo: string,
  texto: string,
  accion: () => void
) => {
  confirmTitle.value = titulo;
  confirmText.value = texto;
  confirmAction.value = () => {
    showConfirmModal.value = false;
    accion();
  };
  showConfirmModal.value = true;
};

const confirmarEliminarEquipo = async () => {
  isLoading.value = true;
  try {
    const response = await eliminarEquipoAsync(props.equipo.idEquipo);

    if (response.status >= 200 && response.status < 300) {
      showSuccessModalEliminarEquipo.value = true;
      emit("delete-team");
    } else {
      showErrorModal.value = true;
    }
  } catch (error) {
    console.error("Error al eliminar el equipo:", error);
    showErrorModal.value = true;
    isLoading.value = false;
  } finally {
    isLoading.value = false;
  }
};

const handlerModalRegistrarMiembroEquipo = async () => {
  const responseJugadores = await getUsuariosNoInscritosTorneoAsync(
    props.torneo.idTorneo
  );
  jugadoresSinEquipo.value = (responseJugadores?.data ?? []).sort(
    (a: { nick: string }, b: { nick: string }) => a.nick.localeCompare(b.nick)
  );
  showModalRegistrarMiembroEquipo.value = true;
};

const closeModal = () => {
  showModalRegistrarMiembroEquipo.value = false;
};
const closeConfigModal = (nuevoMiembro: InscripcionTorneoDTO) => {
  if (nuevoMiembro) {
    if (
      !inscripcionesEquipo.value.some(
        (m) => m.idUsuario === nuevoMiembro.idUsuario
      )
    ) {
      inscripcionesEquipo.value.push(nuevoMiembro);
    }
  }
};

const eliminarMiembro = async (idInscripcion: number) => {
  isCargandoAccion.value = true;
  mensajeCarga.value = "Eliminando jugador...";
  try {
    const response = await eliminarMiembroEquipoAsync(idInscripcion);
    if (
      (response.status < 200 && response.status >= 300) ||
      response.data === false
    ) {
      isCargandoAccion.value = false;
      showErrorModalEliminarMiembroEquipo.value = true;
      return;
    }

    inscripcionesEquipo.value = inscripcionesEquipo.value.filter(
      (miembro) => miembro.idInscripcion !== idInscripcion
    );

    showSuccessModalEliminarMiembroEquipo.value = true;
  } catch (error) {
    console.error("Error al borrar un miembro: ", error);
    showErrorModalEliminarMiembroEquipo.value = true;
  } finally {
    isCargandoAccion.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_v_card, {
      variant: "outlined",
      class: "ma-1 pa-3 text-left tarjeta",
      role: "button",
      tabindex: "0",
      onClick: toggleExpand,
      onKeydown: _withKeys(toggleExpand, ["enter"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.equipo.nombreEquipo), 1),
          (puntosExtraEquipo.value !== 0)
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                size: "x-small",
                variant: "tonal",
                class: "flex-shrink-0"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(puntosExtraEquipo.value > 0 ? "+" : "") + _toDisplayString(puntosExtraEquipo.value) + " " + _toDisplayString(Math.abs(puntosExtraEquipo.value) === 1 ? "punto extra" : "puntos extra"), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_unref(cerrado))
            ? (_openBlock(), _createBlock(_component_v_menu, { key: 1 }, {
                activator: _withCtx(({ props: menuProps }) => [
                  _createVNode(_component_v_btn, _mergeProps({
                    icon: "mdi-dots-vertical",
                    variant: "text",
                    size: "small",
                    density: "comfortable",
                    "aria-label": "Más acciones"
                  }, menuProps, {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }), null, 16)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, { density: "compact" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        "prepend-icon": "mdi-trash-can",
                        "base-color": "error",
                        title: esParejas.value ? 'Borrar pareja' : 'Borrar equipo',
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (
              abrirModalConfirmacion(
                esParejas.value ? '¿Deseas borrar la pareja?' : '¿Deseas borrar el equipo?',
                'Esta acción no se puede deshacer.',
                confirmarEliminarEquipo
              )
            ))
                      }, null, 8, ["title"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(" Capitán: " + _toDisplayString(_ctx.equipo.nickCapitan) + " ", 1),
          (_ctx.equipo.fechaInscripcion)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" · Inscrito " + _toDisplayString(_unref(convertirFecha)(_ctx.equipo.fechaInscripcion)), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (_ctx.equipo.emailCapitan)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.equipo.emailCapitan), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              class: _normalizeClass(["text-no-wrap", inscripcionesEquipo.value.length < numeroMiembrosEquipo.value ? 'text-warning' : 'text-medium-emphasis'])
            }, _toDisplayString(inscripcionesEquipo.value.length) + "/" + _toDisplayString(numeroMiembrosEquipo.value) + " jugadores ", 3),
            _hoisted_7,
            _createElementVNode("span", {
              class: _normalizeClass(["text-no-wrap", equipoIncompleto.value ? 'text-warning' : 'text-success'])
            }, _toDisplayString(listasOk.value) + "/" + _toDisplayString(listasNecesarias.value) + " " + _toDisplayString(esListaConjunta.value ? "lista conjunta validada" : "listas validadas"), 3)
          ]),
          _createVNode(InterruptorPago, {
            esPago: _ctx.equipo.esPago,
            idEquipo: _ctx.equipo.idEquipo,
            onCambiado: pagoCambiado
          }, null, 8, ["esPago", "idEquipo"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createTextVNode(_toDisplayString(isExpanded.value ? "Ocultar miembros" : "Ver miembros") + " ", 1),
          _createVNode(_component_v_icon, {
            size: "small",
            icon: isExpanded.value ? 'mdi-chevron-up' : 'mdi-chevron-down'
          }, null, 8, ["icon"])
        ]),
        _createVNode(_component_v_expand_transition, null, {
          default: _withCtx(() => [
            (isExpanded.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equipoConHuecos.value, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item?.idInscripcion ?? `hueco-${index}`
                    }, [
                      item
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 0,
                            variant: "tonal",
                            class: "pa-2 mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("span", _hoisted_10, [
                                  _createTextVNode(_toDisplayString(item.nick || "Desconocido") + " ", 1),
                                  (item.idUsuario === _ctx.equipo.idCapitan)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " (capitán) "))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(PuntosExtra, {
                                  inscripcion: item,
                                  onCambiado: _cache[2] || (_cache[2] = (idUsuario, puntos) => emit('puntos-extra', idUsuario, puntos))
                                }, null, 8, ["inscripcion"]),
                                _createVNode(_component_v_menu, {
                                  modelValue: isOpenMenuAcciones.value[item.idInscripcion],
                                  "onUpdate:modelValue": ($event: any) => ((isOpenMenuAcciones.value[item.idInscripcion]) = $event)
                                }, {
                                  activator: _withCtx(({ props: menuProps }) => [
                                    _createVNode(_component_v_btn, _mergeProps({
                                      icon: "mdi-dots-vertical",
                                      variant: "text",
                                      size: "small",
                                      density: "comfortable",
                                      "aria-label": "Acciones del jugador"
                                    }, menuProps), null, 16)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, { density: "compact" }, {
                                      default: _withCtx(() => [
                                        (item.email)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 0,
                                              "prepend-icon": "mdi-email-outline",
                                              title: "Escribir correo",
                                              href: `mailto:${item.email}`
                                            }, null, 8, ["href"]))
                                          : _createCommentVNode("", true),
                                        (item.idLista)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 1,
                                              "prepend-icon": "mdi-eye",
                                              title: "Ver lista",
                                              onClick: ($event: any) => (verLista(item.idLista, item.nick, item.ejercito))
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (item.idLista)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 2,
                                              "prepend-icon": "mdi-refresh",
                                              title: "Cambiar estado",
                                              onClick: ($event: any) => (cambiarEstadoLista(item.idInscripcion!, item.estadoLista, item.nick))
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (!esListaConjunta.value || item.idInscripcion === idInscripcionListaPareja.value)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 3,
                                              "prepend-icon": "mdi-pencil",
                                              title: item.listaData ? 'Modificar lista' : 'Enviar lista',
                                              onClick: ($event: any) => (enviarCambiarLista(item.idInscripcion, item.listaData!, item.idUsuario, item.nick, item.idLista))
                                            }, null, 8, ["title", "onClick"]))
                                          : _createCommentVNode("", true),
                                        (!_unref(cerrado))
                                          ? (_openBlock(), _createBlock(_component_v_divider, {
                                              key: 4,
                                              class: "my-1"
                                            }))
                                          : _createCommentVNode("", true),
                                        (!_unref(cerrado))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 5,
                                              "prepend-icon": "mdi-account-remove",
                                              "base-color": "error",
                                              title: esParejas.value ? 'Quitar de la pareja' : 'Quitar del equipo',
                                              onClick: ($event: any) => (
                      abrirModalConfirmacion(
                        esParejas.value ? `¿Quitar a ${item.nick} de la pareja?` : `¿Quitar a ${item.nick} del equipo?`,
                        'Se borran su inscripción y su lista en este torneo. Esta acción no se puede deshacer.',
                        () => eliminarMiembro(item.idInscripcion)
                      )
                    )
                                            }, null, 8, ["title", "onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              (item.email)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.email), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_13, [
                                (item.ejercito)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.ejercito) + " · ", 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", {
                                  class: _normalizeClass(`text-${_unref(estadoLista)(item.estadoLista).color}`)
                                }, _toDisplayString(_unref(estadoLista)(item.estadoLista).texto), 3),
                                (_unref(bandoLista)(item.bando))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, " · " + _toDisplayString(_unref(bandoLista)(item.bando)!.texto), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (item.fechaEntregaLista)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Lista " + _toDisplayString(_unref(formatFechaSpaWhitoutAsync)(item.fechaEntregaLista)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_v_card, {
                            key: 1,
                            variant: "tonal",
                            class: "pa-2 mt-2 d-flex align-center ga-2"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17,
                              (!_unref(cerrado))
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 0,
                                    size: "small",
                                    variant: "tonal",
                                    class: "text-none",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (handlerModalRegistrarMiembroEquipo()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Añadir jugador ")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })), [
      [_directive_ripple]
    ]),
    (showCambiarEstadoLista.value)
      ? (_openBlock(), _createBlock(ModalCambiarEstadoListaEquipos, {
          key: currentInscripcionId.value,
          isVisible: showCambiarEstadoLista.value,
          "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => ((showCambiarEstadoLista).value = $event)),
          idInscripcion: currentInscripcionId.value!,
          "estado-lista": currentEstadoLista.value!,
          nick: currentNick.value!,
          onUpdateInscripcion: cambiarEstado
        }, null, 8, ["isVisible", "idInscripcion", "estado-lista", "nick"]))
      : _createCommentVNode("", true),
    _createVNode(ModalVerLista, {
      isVisible: showVerListaModal.value,
      "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => ((showVerListaModal).value = $event)),
      listaJugador: listaJugador.value!
    }, null, 8, ["isVisible", "listaJugador"]),
    (showEnviarCambiarListaModal.value)
      ? (_openBlock(), _createBlock(ModalEnviarLista, {
          key: currentInscripcionId.value,
          isVisible: showEnviarCambiarListaModal.value,
          "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => ((showEnviarCambiarListaModal).value = $event)),
          idInscripcion: currentInscripcionId.value!,
          idUsuario: currentUsuarioId.value!,
          idTorneo: currentTorneoId.value!,
          emailOrganizador: currentEmailOrganziador.value!,
          nick: currentNick.value!,
          hasLista: hasLista.value,
          onEnviarLista: guardarLista,
          onModificarLista: guardarLista
        }, null, 8, ["isVisible", "idInscripcion", "idUsuario", "idTorneo", "emailOrganizador", "nick", "hasLista"]))
      : _createCommentVNode("", true),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalLista.value,
      message: "Lista enviada con éxito.",
      "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (showSuccessModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalEliminarEquipo.value,
      message: esParejas.value ? 'Pareja eliminada.' : 'Equipo eliminado.',
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showSuccessModalEliminarEquipo.value = $event))
    }, null, 8, ["isVisible", "message"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido actualizar la inscripción. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[10] || (_cache[10] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalEliminarMiembroEquipo.value,
      message: "Miembro eliminado con éxito.",
      "onUpdate:isVisible": _cache[11] || (_cache[11] = ($event: any) => (showSuccessModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModalEliminarMiembroEquipo.value,
      message: "No se ha podido eliminar al miembro del equipo. Inténtelo de nuevo y si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[12] || (_cache[12] = ($event: any) => (showErrorModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalAddMiembroEquipo, {
      isVisible: showModalRegistrarMiembroEquipo.value,
      "onUpdate:isVisible": _cache[13] || (_cache[13] = ($event: any) => ((showModalRegistrarMiembroEquipo).value = $event)),
      idEquipo: _ctx.equipo.idEquipo,
      idTorneo: _ctx.torneo.idTorneo!,
      jugadores: jugadoresSinEquipo.value,
      onClose: closeModal,
      onConfirm: closeConfigModal
    }, null, 8, ["isVisible", "idEquipo", "idTorneo", "jugadores"]),
    _createVNode(_component_v_dialog, {
      modelValue: isLoading.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((isLoading).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isCargandoAccion.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isCargandoAccion).value = $event)),
      persistent: "",
      width: "250",
      "hide-overlay": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "d-flex flex-column justify-center align-center pa-4",
          height: "180"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "50",
              class: "mb-4"
            }),
            _createElementVNode("div", _hoisted_18, _toDisplayString(mensajeCarga.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showConfirmModal.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((showConfirmModal).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(confirmTitle.value), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(confirmText.value), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "grey",
                  variant: "text",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (showConfirmModal.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancelar ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "tonal",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (confirmAction.value?.()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Confirmar ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})